import React, { useState } from 'react';
import { Container, Table, Card, Row, Col } from 'reactstrap';
import UserRoleCard from '../../components/UserRoleCard/UserRoleCard';
import SimpleHeader from '../../components/SimpleHeader/SimpleHeader';
import './RolesAndPermissions.css';
import { useParams } from 'react-router-dom';
import { useRolesQuery, prefetchSystemPermissionDependency } from '../../utilities/queries/useRolesQuery';
import EditRolePermissionsModal from './EditRolePermissionsModal';
import DCGToastMessage from '../../components/ToastMessage/DCGToastMessage';
import SearchInput from '../../components/Search/SearchInput';
import Spinner from '../../components/UISpinner/UISpinner';
import { useStore, toastToggleCallback, makeToast } from '../../utilities/appStore';


const RolesAndPermissionsDashboard = () => {
    let toast = useStore((state) => state.toast);
    const { orgId } = useParams();
    
    const [search, setSearch] = useState('');

    const [isModalOpen, setModalOpen] = useState(false);
    const [modalData, setModalData] = useState({
        roleName: '',
        roleType: '',
        roleId: ''
    });


    
    const rolesTableMaxHeight = '500px';
    const { data: roles, isLoading, error } = useRolesQuery();
 
    let filteredRoles = [];
    if (!error) {
        filteredRoles = roles && roles.length > 0 ? roles.filter(role =>
            role.roleName.toLowerCase().includes(search.toLowerCase())
        ) : [];
    }
    const toggleModal = () => {
        setModalOpen(!isModalOpen);
        setModalData({
            roleName: '',
            roleType: '',
            roleId: ''
        });
    }

    return (
        <>
            {toast?.display && <DCGToastMessage isOpen={true} Message={toast?.message} Type={toast.type} ToggleCallback={toastToggleCallback} />}
            {modalData?.roleId && <EditRolePermissionsModal isOpen={isModalOpen} toggle={toggleModal} data={modalData} makeToast={makeToast} />}
            <SimpleHeader name="Home" parentName="Hierarchy  Management" />
            <Container className="mt--6" fluid>
                <Row className="justify-content-center">
                    <Col className="card-wrapper">
                        <Card className="card-header-devices p-3">
                            <h2 className="ml-4 mb-4">User Permission Roles</h2>
                            {/* Search bar */}
                            {/* <SearchInput value={search} onChange={e => setSearch(e.target.value)} className="mb-3" />*/}
                            {isLoading && <Spinner text="Loading roles..." />}
                            {/* Roles Table */}
                            {!isLoading && <div onMouseEnter={prefetchSystemPermissionDependency} className="table-responsive overflow-y-auto" style={{ maxHeight: rolesTableMaxHeight }}>
                                <Table className="align-items-center table-flush table" striped>
                                    <thead className="position-sticky top-0 thead-light" style={{ zIndex: 2 }}>
                                        <tr>
                                            <th className="text-start">Role Name</th>
                                            <th className="text-end">Last Updated</th>
                                            <th className="text-end">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredRoles.map((role, index) => (
                                            <UserRoleCard key={index} role={role} updateModalData={setModalData} openModal={() => setModalOpen(true)} />
                                        ))}
                                    </tbody>
                                </Table>
                            </div>}
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};


export default RolesAndPermissionsDashboard;
